import '@/styles/bPaginationStyle.scss'
import '@/styles/bTableStyle.scss'
import '@/styles/cssOverrides.css'
import '@/styles/pikadayStyles.scss'

import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'

// plugins
import { initializePlausible } from '@/helpers/initializePlausible'
import { useBootstrapPlugin } from '@/plugins/bootstrapPlugin.js'
import { FeatureFlagPlugin } from '@/plugins/featureFlagPlugin.js'
import { i18n } from '@/plugins/i18n.js'
import { initializeSentry } from '@/plugins/sentryPlugin.js'
import { UserPermissionPlugin } from '@/plugins/userPermissionPlugin.ts'
import { toastPlugin } from '@attensi/materia'
import { abilitiesPlugin } from '@/ability/abilityPlugin'
import { VueQueryPlugin, QueryClient } from '@tanstack/vue-query'
import { queryClientConfig } from '@/queries/queryClientConfig'

// directives
import './directives/query-params'
import './directives/sanitize-html'

// config
import { IS_PROD_BUILD } from '@/environment'
import {
  getCompanyNameKey,
  getSubdomain,
  revalidateActiveSession,
} from '@/service/activeSession'
import { initializeAppLauncher, redirectToLogin } from '@/service/loginActions'
import createRouter from './router'
import store from './store/'

// tippy
import LayoutComponent from '@/components/layout/Layout.vue'
import ViewWrapper from '@/components/layout/view_wrapper/ViewWrapper.vue'

startApp().catch((e) => {
  console.error(e)
  alert(e.message)
})

async function startApp() {
  await revalidateActiveSession()
  const subdomain = await getSubdomain()
  const company = await getCompanyNameKey()

  if (!subdomain) {
    await redirectToLogin()
    return
  }

  Vue.component('Layout', LayoutComponent)
  Vue.component('ViewWrapper', ViewWrapper)

  useBootstrapPlugin(Vue)

  // Create QueryClient instance with config
  const queryClient = new QueryClient(queryClientConfig)
  Vue.use(VueQueryPlugin, { queryClient }) // TODO: Determine a sensible default config for the project
  Vue.use(abilitiesPlugin)
  Vue.use(toastPlugin)
  Vue.use(FeatureFlagPlugin)
  Vue.use(UserPermissionPlugin)
  Vue.config.productionTip = false
  Vue.config.devtools = !IS_PROD_BUILD

  const router = createRouter(subdomain)

  initializeSentry(subdomain, company, router)
  initializePlausible()
  await initializeAppLauncher()

  new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app')
}
